import React from 'react';


// const ProblematicLogEntry = ({ lastSubmitDate, lastTitle, lastDescription, lastLesson, lastImpact }) => { 
//     return (
//         <div>
//             <h4 className="text-center"> { lastTitle } </h4>
//             <p className="text-center"> { lastDescription } </p>
//             <div className="container">
//                 <div className="item">
//                     Key Lessons
//                     <div className='left-text'>
//                         <p> { lastLesson } </p>
//                     </div>
//                 </div>
//                 <div className="item">
//                     Impact
//                     <div>
//                         <p> { lastImpact } </p>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default ProblematicLogEntry;

import { useState } from "react";
import './css//ProblematicLogEntry.css'; // CSS file for styling

const AccordionSection = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="accordion-section">
            <button 
                className="accordion-toggle" 
                onClick={() => setIsOpen(!isOpen)}
                aria-expanded={isOpen}
            >
                <span>{title}</span>
                <span className="accordion-icon">{isOpen ? '−' : '+'}</span>
            </button>
            {isOpen && <div className="accordion-content">{children}</div>}
        </div>
    );
};

const ProblematicLogEntry = ({ lastTitle, lastDescription, lastLesson, lastImpact }) => {
    return (
        <div className="log-entry-card">
            <h2 className="log-title">{lastTitle}</h2>

            <AccordionSection title="Description">
                <p>{lastDescription}</p>
            </AccordionSection>

            <AccordionSection title="Key Lessons">
                <p>{lastLesson}</p>
            </AccordionSection>

            <AccordionSection title="Impact">
                <p>{lastImpact}</p>
            </AccordionSection>
        </div>
    );
};

export default ProblematicLogEntry;